import { store } from "@src/store";
import {
  showSuccessToast,
  showErrorToast,
  removeToast,
  IToastOption,
  IToast,
} from "@src/@slice/toastSlice";

import { PartnerType } from "@src/define/partner";
import { HOSTNAME, isExternalUrl } from "@src/utils";

export type { IToast };

class Toast {
  // defalut action
  success(message: string|JSX.Element, options?: IToastOption) {
    store.dispatch(showSuccessToast({ message, ...options }));
  }
  error(message: string|JSX.Element, options?: IToastOption) {
    store.dispatch(showErrorToast({ message, ...options }));
  }
  remove(toastId: number | string) {
    store.dispatch(removeToast(toastId));
  }
  // 동일한 이름을 가진 토스트가 존재하는지 확인
  hasToast(toastId: number | string): boolean {
    const state = store.getState();
    return state.toast.toasts.some((toast: IToast) => toast.id === toastId);
  }
  // --------------------- special action
  // 업체 찜하기 토스트
  showLikeToast(currentIsLike: boolean, partnerType?: number) {
    let likePageUrl = "";
    if (partnerType === PartnerType.Planner) {
      likePageUrl = `${HOSTNAME}/my-interest/like/planner?tab=planner`;
    } else {
      likePageUrl = `${HOSTNAME}/my-interest/like/partner?tab=${partnerType || 0}`;
    }

    let message = "";
    let toastOptions: IToastOption = {};

    if (currentIsLike === false) {
      message = "찜 목록에 추가했습니다.";
      toastOptions = {
        link: {
          text: "찜 목록 보기",
          url: isExternalUrl(likePageUrl),
        },
      };
    } else {
      message = "찜 목록에서 삭제했습니다.";
      toastOptions = {
        isShowClose: true,
      };
    }

    store.dispatch(showSuccessToast({ message, ...toastOptions }));
  }
  // 포트폴리오 찜하기 토스트
  showPortfolioLikeToast(currentIsLike: boolean) {
    let message = "";
    let toastOptions: IToastOption = {};

    if (currentIsLike === false) {
      message = "찜 목록에 추가했습니다.";
      toastOptions = {
        link: {
          text: "찜 목록 보기",
          url: isExternalUrl(`${HOSTNAME}/my-interest/like/planner?tab=portfolio`),
        },
      };
    } else {
      message = "찜 목록에서 삭제했습니다.";
      toastOptions = {
        isShowClose: true,
      };
    }

    store.dispatch(showSuccessToast({ message, ...toastOptions }));
  }
}

const _instance = new Toast();
export default _instance;
